import { create } from 'zustand';
import { doGet } from '../../http';
import { selectLocale } from '../selectors';

export const createHotelGroupSlice = (set, get) => ({
  hotelGroup: null,
  fetchHotelGroup: async () => {
    const hotelId = get().config?.hotelId;
    const hotelGroupId = get().hotelInfo?.hotel_group_id;
    const locale = selectLocale(get());

    if (!hotelId) {
      console.warn('Failed to fetch hotel group: No Hotel ID.');
      return;
    };

    if (!hotelGroupId) {
      console.warn('Failed to fetch hotel group: No Hotel Group ID.');
      return;
    };

    try {
      const res = await doGet(({ baseUrl, hotelId }) => `${baseUrl}/hotels/${hotelId}/hotel_groups/${hotelGroupId}?language=${locale}`, {
        'content-type': 'application/json',
      });
      const data = await res.json();

      if (import.meta.env.VITE_LOG_HOTEL_DATA) {
        console.log('fetchHotelGroup:', data);
      }

      set({ hotelGroup: data });
    } catch (err) {
      console.error('Failed to fetch hotel group', err);
    }
  },
});
